"use client";
import { useLayoutEffect, useRef } from "react";
import gsap from "gsap";

export default function TransitionView({ children }: { children: React.ReactNode }) {
  const maskRef = useRef<HTMLDivElement | null>(null);

  useLayoutEffect(() => {
    const mask = maskRef.current;
    if (!mask) return;

    // Awal: circle kecil di tengah
    gsap.set(mask, { clipPath: "circle(150% at 50% 50%)" });

    // Animasi masuk: expand ke full
    gsap.to(mask, {
      clipPath: "circle(0% at 50% 50%)",

      duration: 1.2,
      ease: "power4.inOut",
      onComplete: () => {
        // Hapus mask setelah transisi selesai
        gsap.to(mask, {
          autoAlpha: 0,
          duration: 0.5
        });
      }
    });
  }, []);

  return (
    <>
      {/* Mask transparan */}
      <div ref={maskRef} className='fixed inset-0 z-[9999] bg-beige-900 pointer-events-none'></div>

      {/* Konten halaman */}
      <div className='relative'>{children}</div>
    </>
  );
}
